import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../hooks/useDebouncedCallback'
import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { useTrackCustomerModal } from '../../../../hooks/useTrackCustomerModal'
import { AddressInputFieldProps } from '../../types/addressInputFieldProps'

type AddressStreet2Props = AddressInputFieldProps

export const AddressStreet2 = ({ isDisabled = false }: AddressStreet2Props): ReactElement => {
  const { t } = useTranslation()
  const { trackCustomerModal } = useTrackCustomerModal()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  const handleDebouncedAddressStreetInputChange = useDebouncedCallback(() =>
    trackCustomerModal('Second address line typed'),
  )

  return (
    <FormItem
      label={t('customer_modal.form.address.street_address_2.label')}
      name="address.streetAddress2"
      render={({ field: { onChange, ...rest } }) => (
        <Input
          {...rest}
          disabled={isDisabled}
          onChange={(event) => {
            onChange(event)
            handleDebouncedAddressStreetInputChange()
          }}
          size="sm"
        />
      )}
    />
  )
}
